import { useNavigate } from 'react-router-dom';

interface Props {
  message: string;
}

export default function UpgradeBanner({ message }: Props) {
  const navigate = useNavigate();
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 12,
      background: '#fffbeb',
      border: '1px solid #f59e0b',
      borderRadius: 8,
      padding: '10px 14px',
      marginBottom: 12,
    }}>
      <span style={{ fontSize: '.875rem', color: '#92400e', fontWeight: 500 }}>
        🔒 {message}
      </span>
      <button
        onClick={() => navigate('/account')}
        style={{
          background: 'var(--yellow, #f59e0b)',
          color: '#fff',
          border: 'none',
          borderRadius: 6,
          padding: '5px 12px',
          fontSize: '.8rem',
          fontWeight: 700,
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          flexShrink: 0,
        }}
      >
        Upgrade to Pro
      </button>
    </div>
  );
}
